import React from 'react';
import { Main } from './components';

const InvoicesOrders = () => <Main />;

export default InvoicesOrders;
